import { IsEmail, IsNotEmpty } from 'class-validator';

export class CustomerFormData {
    @IsNotEmpty()
    @IsEmail()
    email: string;

    @IsNotEmpty()
    password: string;

    @IsNotEmpty()
    firstName: string;

    @IsNotEmpty()
    lastName: string;
    
}
